import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import AnswerToolbar from "./AnswerToolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import SurveyVote from "./SurveyVote";
import SurveyResults from "./SurveyResults";
import Loader from "../common/Loader";

export interface SurveyParams {
  meetingId: number;
  surveyId: number;
}
const SurveyContainerVoteResults: React.FC<SurveyParams> = ({
  meetingId,
  surveyId,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {selectedLanguageId} = rootStore.commonStore;
  const {
    view,
    LoadSurveyResultDetails,
    surveyResultDetails,
    resetSurveyResultDetail,
    loadSurveyAnswerDetail,
    surveyAnswersDetail
  } = rootStore.surveyStore;

  useEffect(() => {
    LoadSurveyResultDetails(meetingId, surveyId, selectedLanguageId);
    loadSurveyAnswerDetail(meetingId, surveyId, selectedLanguageId);

    return () => {
      resetSurveyResultDetail();
    };
  }, [LoadSurveyResultDetails, meetingId, surveyId, resetSurveyResultDetail]);

  if (!surveyResultDetails || !surveyAnswersDetail ) return <Loader />;


  return (
    <div>
      {/* valorizzare con il giusto surveyId */}
      <AnswerToolbar
        surveyId={surveyId}
        surveyResultDetails={surveyResultDetails}
      />
      {(view === "vote" && ( surveyResultDetails.permissions.canVote || surveyResultDetails.permissions.hasVote))? <SurveyVote meetingId={meetingId}></SurveyVote> : null}
      {view === "result" ? (
        <SurveyResults surveyResultDetails={surveyResultDetails} />
      ) : null}
    </div>
  );
};

export default observer(SurveyContainerVoteResults);
